import { api } from './api';
import { Fornecedor, FornecedorFormData, FornecedoresResponse } from '../types/fornecedor';

export class FornecedorService {
  // Buscar todos os fornecedores
  static async buscarFornecedores(page: number = 1, limit: number = 10): Promise<FornecedoresResponse> {
    try {
      const response = await api.get<FornecedoresResponse>(`/fornecedores?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar fornecedores:', error);
      throw new Error('Erro ao buscar fornecedores');
    }
  }

  // Buscar fornecedor por ID
  static async buscarFornecedorPorId(id: number): Promise<Fornecedor> {
    try {
      const response = await api.get<{ success: boolean; data: Fornecedor }>(`/fornecedores/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Erro ao buscar fornecedor:', error);
      throw new Error('Erro ao buscar fornecedor');
    }
  }

  // Criar novo fornecedor
  static async criarFornecedor(data: FornecedorFormData): Promise<Fornecedor> {
    try {
      const response = await api.post<{ success: boolean; data: Fornecedor }>('/fornecedores', data);
      return response.data.data;
    } catch (error) {
      console.error('Erro ao criar fornecedor:', error);
      throw new Error('Erro ao criar fornecedor');
    }
  }

  // Atualizar fornecedor existente
  static async atualizarFornecedor(id: number, data: FornecedorFormData): Promise<Fornecedor> {
    try {
      const response = await api.put<{ success: boolean; data: Fornecedor }>(`/fornecedores/${id}`, data);
      return response.data.data;
    } catch (error) {
      console.error('Erro ao atualizar fornecedor:', error);
      throw new Error('Erro ao atualizar fornecedor');
    }
  }

  // Excluir fornecedor
  static async excluirFornecedor(id: number): Promise<void> {
    try {
      await api.delete(`/fornecedores/${id}`);
    } catch (error) {
      console.error('Erro ao excluir fornecedor:', error);
      throw new Error('Erro ao excluir fornecedor');
    }
  }

  // Buscar fornecedores com filtros
  static async buscarFornecedoresComFiltros(filtros: {
    page?: number;
    limit?: number;
    search?: string;
    cidade?: string;
    estado?: string;
    vendedor?: string;
  }): Promise<FornecedoresResponse> {
    try {
      const queryParams = new URLSearchParams();
      
      if (filtros.page) queryParams.append('page', filtros.page.toString());
      if (filtros.limit) queryParams.append('limit', filtros.limit.toString());
      if (filtros.search) queryParams.append('search', filtros.search);
      if (filtros.cidade) queryParams.append('cidade', filtros.cidade);
      if (filtros.estado) queryParams.append('estado', filtros.estado);
      if (filtros.vendedor) queryParams.append('vendedor', filtros.vendedor);

      // Se há filtros específicos, usar a rota de busca
      const hasFilters = filtros.search || filtros.cidade || filtros.estado || filtros.vendedor;
      const endpoint = hasFilters ? '/fornecedores/search' : '/fornecedores';
      
      const response = await api.get(`${endpoint}?${queryParams.toString()}`);
      
      return response as unknown as FornecedoresResponse;
    } catch (error) {
      console.error('Erro ao buscar fornecedores com filtros:', error);
      throw new Error('Erro ao buscar fornecedores');
    }
  }
}
